// baseurl.js

 
export const baseurl = "https://invoice.rakhisinghmakeovers.com/api"; 
export const API = "https://invoice.rakhisinghmakeovers.com/api"; 



 


// export const baseurl = "http://192.168.1.2:5000/api"; 
// export const API = "http://192.168.1.2:5000/api"; 


// export const baseurl = "http://localhost:5000/api"; 
// export const API = "http://localhost:5000/api"; 
 
export const imgurl = "https://invoice.rakhisinghmakeovers.com"; 
// export const imgurl = "http://192.168.1.2:5000"; 


 